export default "__VITE_ASSET__Beii_9Yt__"